module.exports = __webpack_public_path__ + "img/ek.e1968d91.jpg";